import React from "react";

const Card = ({ children }) => {
  return (
    <div className="bg-white shadow rounded py-10 px-24 mt-5">{children}</div>
  );
};

export default Card;
